import { useCallback, useContext } from "react";
import { FingerprintHookType } from "./fingerprint-context.types";
import { FingerprintContext } from "./fingerprint-context";

export const useFingerprint = (): FingerprintHookType => {
  const { fingerprint, setFingerprint } = useContext(FingerprintContext);

  const createFingerprint = useCallback(
    (fp: any): void => {
      setFingerprint(fp);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [fingerprint]
  );

  return {
    fingerprint,
    createFingerprint,
  };
};
